"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.fetch = exports.cookie = exports.baseURL = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.object.assign.js");
var _fetch = _interopRequireDefault(require("@zz/fetch"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _ = require(".");
// isServer 表示是否为ssr项目

// 目前前端有三个域名，不同域名下接口请求不同的host
var apiDomainMap = {
  '.zhuanzhuan.com': 'https://app.zhuanzhuan.com',
  '.58.com': 'https://zhuan.58.com',
  '.caihuoxia.com': 'https://app.caihuoxia.com'
};
var getApiDomain = function getApiDomain() {
  var key = location.host.replace(/[\dA-Za-z]{1,}\./, '.');
  return apiDomainMap[key] || 'https://app.zhuanzhuan.com';
};
var baseURL = _.isServer ? 'https://app.zhuanzhuan.com' : getApiDomain();
exports.baseURL = baseURL;
var fetch = function fetch(options) {
  return (0, _fetch.default)(Object.assign({}, options, {
    baseURL: baseURL,
    timeout: 60000
  }));
};
exports.fetch = fetch;
var cookie = _jsCookie.default.withConverter({
  write: function write(value, key) {
    return value;
  },
  read: function read(value) {
    return value;
  }
});
exports.cookie = cookie;